export default "__VITE_ASSET__BhGvyG7F__"